/**
 * New Stack, swap direction based on type ='row' | 'column'
 **/
export var StackType;
(function (StackType) {
    StackType["row"] = "row";
    StackType["column"] = "column";
})(StackType || (StackType = {}));
/**
 * Allow common alignment for both x-axis and y-axis
 **/
/** @deprecated
 *
 */
export var StackAlignType;
(function (StackAlignType) {
    StackAlignType["center"] = "center";
    StackAlignType["flexStart"] = "flex-start";
    StackAlignType["flexEnd"] = "flex-end";
    StackAlignType["spaceBetween"] = "space-between";
    StackAlignType["spaceEvenly"] = "space-evenly";
})(StackAlignType || (StackAlignType = {}));
export var StackJustifyContent;
(function (StackJustifyContent) {
    StackJustifyContent["center"] = "center";
    StackJustifyContent["flexStart"] = "flex-start";
    StackJustifyContent["flexEnd"] = "flex-end";
    StackJustifyContent["spaceBetween"] = "space-between";
    StackJustifyContent["spaceAround"] = "space-around";
    StackJustifyContent["spaceEvenly"] = "space-evenly";
})(StackJustifyContent || (StackJustifyContent = {}));
export var StackAlignItems;
(function (StackAlignItems) {
    StackAlignItems["center"] = "center";
    StackAlignItems["flexStart"] = "flex-start";
    StackAlignItems["flexEnd"] = "flex-end";
    StackAlignItems["stretch"] = "stretch";
    StackAlignItems["baseline"] = "baseline";
})(StackAlignItems || (StackAlignItems = {}));
export var StackFlexWrap;
(function (StackFlexWrap) {
    StackFlexWrap["wrap"] = "wrap";
    StackFlexWrap["nowrap"] = "nowrap";
    StackFlexWrap["wrapReverse"] = "wrap-reverse";
})(StackFlexWrap || (StackFlexWrap = {}));
export var StackWidth;
(function (StackWidth) {
    StackWidth["FULL"] = "FULL";
    StackWidth["CONTENT"] = "CONTENT";
    StackWidth["MATCH_PARENT"] = "MATCH_PARENT";
})(StackWidth || (StackWidth = {}));
export var StackHeight;
(function (StackHeight) {
    StackHeight["FULL"] = "FULL";
    StackHeight["CONTENT"] = "CONTENT";
    StackHeight["MATCH_PARENT"] = "MATCH_PARENT";
})(StackHeight || (StackHeight = {}));
export var StackAlignContent;
(function (StackAlignContent) {
    StackAlignContent["center"] = "center";
    StackAlignContent["flexStart"] = "flex-start";
    StackAlignContent["flexEnd"] = "flex-end";
    StackAlignContent["stretch"] = "stretch";
    StackAlignContent["baseline"] = "baseline";
})(StackAlignContent || (StackAlignContent = {}));
export var StackSelfContent;
(function (StackSelfContent) {
    StackSelfContent["center"] = "center";
    StackSelfContent["flexStart"] = "flex-start";
    StackSelfContent["flexEnd"] = "flex-end";
    StackSelfContent["stretch"] = "stretch";
    StackSelfContent["baseline"] = "baseline";
})(StackSelfContent || (StackSelfContent = {}));
export var StackPositionType;
(function (StackPositionType) {
    StackPositionType["absolute"] = "absolute";
    StackPositionType["relative"] = "relative";
})(StackPositionType || (StackPositionType = {}));
